module.exports = __webpack_public_path__ + "fonts/iconfont.46438fa5.ttf";